module.exports = __webpack_public_path__ + "static/media/Flexnor-350x210.b3eb0ec2.jpg";